module.exports = __webpack_public_path__ + "media/images/about-me-44b62d5e98e5f61720f50f14fc002678.jpg";